import { lazy, Suspense, useEffect } from "react";
import { Box, Link, Text } from "@chakra-ui/react";
import {
  Link as RouterLink,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { Provider } from "urql";
import { teachingClient } from "./graphql/teaching";
import { ROUTES } from "./constants/routes";
import Loader from "./components/common/Loader";
import Layout from "./layouts/Layout";
import { ThemeProvider } from "./contexts/theme";

const Micropractices = lazy(() => import("./pages/Micropractices"));
const MicropracticeDetail = lazy(() => import("./pages/MicropracticeDetail"));
const CoreToolPosters = lazy(() => import("./pages/CoreToolPosters"));

// No auth/session, notification, translation, support form, tour or replay providers.
const PublicTeachingApp = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return (
    <Provider value={teachingClient}>
      <ThemeProvider>
        <Layout isAuthenticated={false} publicOnly>
          <Suspense fallback={<Loader height="50vh" width="full" />}>
            <Routes>
              <Route
                path={ROUTES.micropractices}
                element={<Micropractices />}
              />
              <Route
                path={ROUTES.micropractice_detail}
                element={<MicropracticeDetail />}
              />
              <Route
                path={ROUTES.core_tools_posters}
                element={<CoreToolPosters />}
              />
              <Route
                path={`${ROUTES.core_tools_posters}/:region`}
                element={<CoreToolPosters />}
              />
              <Route
                path="*"
                element={
                  <Box p={8}>
                    <Text>This page was not found.</Text>
                    <Link as={RouterLink} to={ROUTES.micropractices}>
                      Back to micropractices
                    </Link>
                  </Box>
                }
              />
            </Routes>
          </Suspense>
        </Layout>
      </ThemeProvider>
    </Provider>
  );
};
export default PublicTeachingApp;
